/**
 * @generated SignedSource<<ab83753d7ad41904801b8bcf58ea34e5>>
 * @relayHash 134b31c16b29681964688b4096a2ad19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9dc1d36a8c3d091e948924ac2b597bd9e5c72ca193a44a780d627e6f5e49a43

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessListEmbedQuery } from './src_jiraBusinessListEmbedQuery.graphql';

import withNewRankField_provider from '@atlassian/jira-relay-provider/src/fun-1500-swap-business-inline-create-rank-fetcher.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessListEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d9dc1d36a8c3d091e948924ac2b597bd9e5c72ca193a44a780d627e6f5e49a43",
    "metadata": {},
    "name": "src_jiraBusinessListEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider": withNewRankField_provider
    }
  }
};

export default node;
